<template>
  <div class="row m-0 logo_bg h-100">
    <div class="col-12 bg pt-3 pb-3 h-10">
      <div class="row m-0 align-items-center justify-content-between">
        <div class="col-1">
          <img src="../assets/images/time.png" class="img-fluid">
        </div>
        <div class="col-3 text-right text_white font84">
          {{ elapsedMs }}<span class="font76">s</span>
        </div>
      </div>
    </div>
    <div class="col-12 pb-5">
      <div class="row m-0 pb-4">
        <div class="col-4">
          <div class="row m-0 justify-content-center">
            <div class="col-8 mb-1">
              <img :src="image1" class="img-fluid">
            </div>
            <div class="col-12">
              <div class="row m-0 selection_holder justify-content-center">
                <div class="col-6 selection">
                  <gameselections :imageQuad.sync="firstImageQuad" :position="1" colour="white"></gameselections>
                </div>
                <div class="col-6 selection">
                  <gameselections :imageQuad.sync="firstImageQuad" :position="2" colour="blue"></gameselections>
                </div>
                <div class="col-6 selection">
                  <gameselections :imageQuad.sync="firstImageQuad" :position="3" colour="grey"></gameselections>
                </div>
                <div class="col-6 selection">
                  <gameselections :imageQuad.sync="firstImageQuad" :position="4" colour="gold"></gameselections>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="row m-0 justify-content-center">
            <div class="col-8 mb-1">
              <img :src="image2" class="img-fluid">
            </div>
            <div class="col-12">
              <div class="row m-0 selection_holder justify-content-center">
                <div class="col-6 selection">
                  <gameselections :imageQuad.sync="secondImageQuad" :position="1" colour="white"></gameselections>
                </div>
                <div class="col-6 selection">
                  <gameselections :imageQuad.sync="secondImageQuad" :position="2" colour="blue"></gameselections>
                </div>
                <div class="col-6 selection">
                  <gameselections :imageQuad.sync="secondImageQuad" :position="3" colour="grey"></gameselections>
                </div>
                <div class="col-6 selection">
                  <gameselections :imageQuad.sync="secondImageQuad" :position="4" colour="gold"></gameselections>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="row m-0 justify-content-center">
            <div class="col-8 mb-1">
              <img :src="image3" class="img-fluid">
            </div>
            <div class="col-12">
              <div class="row m-0 selection_holder justify-content-center">
                <div class="col-6 selection">
                  <gameselections :imageQuad.sync="thirdImageQuad" :position="1" colour="white"></gameselections>
                </div>
                <div class="col-6 selection">
                  <gameselections :imageQuad.sync="thirdImageQuad" :position="2" colour="blue"></gameselections>
                </div>
                <div class="col-6 selection">
                  <gameselections :imageQuad.sync="thirdImageQuad" :position="3" colour="grey"></gameselections>
                </div>
                <div class="col-6 selection">
                  <gameselections :imageQuad.sync="thirdImageQuad" :position="4" colour="gold"></gameselections>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-end abs">
      <div class="col-4">
        <div class="row m-0">
          <div class="col-12 text-right">
            <button :disabled="!canProceed" @click="completed()" class="btn btn-gradient pl-5 pr-5">Complete</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GameSelections from './partials/GameSelections.vue'
import { mapGetters, mapActions } from 'vuex'
import { firestore } from '@/firebase.config'
export default {
  name: 'Game',
  components: {
    'gameselections': GameSelections
  },
  computed: {
    ...mapGetters([
      'selectedIcons',
      'code',
      'imageQuadAnswers',
      'timeStart',
      'timeEnd'
    ]),
    canProceed () {
      return this.firstImageQuad !== -1 && this.secondImageQuad !== -1 && this.thirdImageQuad !== -1
    },
    image1 () {
      return require('../assets/images/icons/' + this.selectedIcons[0] + '.png')
    },
    image2 () {
      return require('../assets/images/icons/' + this.selectedIcons[1] + '.png')
    },
    image3 () {
      return require('../assets/images/icons/' + this.selectedIcons[2] + '.png')
    }
  },
  data () {
    return {
      firstImageQuad: -1,
      secondImageQuad: -1,
      thirdImageQuad: -1,
      elapsedMs: 90,
      timerId: null
    }
  },
  mounted () {
    let vm = this
    this.setTimeStart()
    vm.timerId = setInterval(function () {
      console.log(--vm.elapsedMs)
      if (vm.elapsedMs <= 0) {
        clearInterval(vm.timerId)
        console.log('here')
        vm.$router.push('/timesup')
      }
    }, 1000)
  },
  methods: {
    ...mapActions([
      'setTimeStart',
      'setTimeEnd'
    ]),
    completed () {
      this.setTimeEnd()
      clearInterval(this.timerId)
      let vm = this
      let allCorrect = true
      vm.selectedIcons.forEach((item, index) => {
        let imgNum = item.replace('.png', '')
        // console.log('index', index)
        switch (index) {
          case 0:
            if (vm.imageQuadAnswers['.value'][imgNum].quad !== vm.firstImageQuad) {
              allCorrect = false
            }
            break
          case 1:
            if (vm.imageQuadAnswers['.value'][imgNum].quad !== vm.secondImageQuad) {
              allCorrect = false
            }
            break
          case 2:
            if (vm.imageQuadAnswers['.value'][imgNum].quad !== vm.thirdImageQuad) {
              allCorrect = false
            }
            break
        }
      })
      console.log('allCorrect', allCorrect)
      let timeTaken = vm.timeEnd - vm.timeStart < 90000 ? vm.timeEnd - vm.timeStart : 90000
      firestore.collection('participants').doc(vm.code).update({
        timeTaken: timeTaken,
        completed: allCorrect
      }).then(ref => {
        if (allCorrect) {
          this.$router.push('/congrats')
        } else {
          this.$router.push('/incorrect')
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
  background: -webkit-linear-gradient(0deg, rgb(0, 75, 141) 0%, rgb(185, 140, 96) 100%);
}
.font84 {
  font-size: 84px;
  font-family: 'open-sans-extra-bold';
  line-height: 1;
}
.font76 {
  font-size: 76px;
  font-family: 'open-sans-extra-bold';
  line-height: 1;
}
.grey {
  color: grey;
}
.abs {
  position: absolute;
  bottom: 3vh;
  width: 100%;
}
.btn-gradient {
  background: -webkit-linear-gradient(0deg, rgb(0, 75, 141) 0%, rgb(185, 140, 96) 95%);
  border-radius: 0;
  border: none;
  color: #fff;
}
.logo_bg {
  background-image: url("../assets/images/bg_logo.png");
  background-size: cover;
  background-position: 0px 40vh;
  background-repeat: no-repeat;
}
.h-10 {
  max-height: 116px;
}
.selection_holder {
  height: 32vh;
}
.selection {
  height: 15vh;
  width: 15vh;
  max-width: 15vh;
  padding: 0 0.5vh 1vh 0.5vh;
}

</style>



// WEBPACK FOOTER //
// src/components/Game.vue